import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from "@material-ui/core/Typography";
import InformationBox from '../../components/InformationBox';

import DropdownSelect from '../DropdownSelect';
import AutocompleteSelectWithEntry from '../AutocompleteSelectWithEntry';
import {getDefaultYear} from '../../utils/impactUtils';
import MetricSheet from '../MetricSheet';

import 'react-datasheet/lib/react-datasheet.css';

const useStyles = makeStyles(() => ({
    metricDropdown: {
        width: '100%',
        margin: '1rem'
    },
    structureDropdown: {
        width: '30%',
        margin: '1rem',
        visibility: 'hidden'
    }
}));

export default function WorkOptimizationCard({ impact, updateImpact, updateMetric, createMetricYear, refreshValues, disabled, targetDisabled }) {
    const { id: valueId, woMetric, structureId, metricYears } = impact;
    const [ valueMetric, setValueMetric ] = useState(woMetric);
    const [ valueStructure, setValueStructure ] = useState(structureId);
    const [ currentYear, setCurrentYear ] = useState(getDefaultYear(metricYears));
    const classes = useStyles();

    useEffect(() => {
        setValueMetric(impact.woMetric);
        setValueStructure(impact.structureId);
    }, [impact.woMetric, impact.structureId]);

    const onYearChange = (year) => {
        refreshValues();
        setCurrentYear(year);
    };

    const onMetricChange = (e) => {
        setValueMetric(e.target.value);
    };

    const onMetricBlur = (e) => {
        updateImpact(valueId, 'woMetric', e.target.value, () => {});
    };

    const onStructureChange = (e, c) => {
        updateImpact(valueId, 'structureId', e.target.value, () => { setValueStructure(e.target.value); });
    };

    return (
        <div style={{width: '100%'}}>
            {/* <Typography variant='body1' style={{width: '100%'}}>
                What is the metric we can use to measure the change created by this initiative?
            </Typography> */}
            <InformationBox text='What is the metric we can use to measure the change created by this initiative?' description={'Enter a non-cash metric (free text field) that will measure the value and demonstrate the effectiveness of the initiative'} variant={'1rem'}/>
            <br/>
            <div style={{display: 'flex', width: '100%'}}>
                <AutocompleteSelectWithEntry
                  dropdownList={['Number of hours returned to the business']}
                  label='Baseline unit of measure'
                  onBlur={onMetricBlur}
                  onChange={onMetricChange}
                  className={classes.metricDropdown}
                  value={valueMetric || ''}
                  disabled={disabled}
                  width={'70%'}
                />
                <DropdownSelect
                    controlClass={classes.structureDropdown}
                    variant='outlined'
                    size='small'
                    label='Metric Structure'
                    labelId='structure-label'
                    onChange={onStructureChange}
                    value={valueStructure || ''}
                    dropdownName={'ValueStructure'}
                    disabled={disabled}
                />
            </div>
            <MetricSheet
                impact={impact}
                currentYear={currentYear}
                onYearChange={onYearChange}
                updateMetric={updateMetric}
                createMetricYear={createMetricYear}
                disabled={disabled}
                formatNumbersAsCurrency={false}
                targetDisabled={targetDisabled}
            />
        </div>
    );
}

WorkOptimizationCard.defaultProps = {
    impact: {
        id: '',
        metricId: '',
        structureId: ''
    }
};
